import { useRef } from 'react';

export const usePrevious = (value) => {
  const previous = useRef();
  const current = useRef();

  if (value !== current.current) {
    previous.current = current.current;
    current.current = value;
  }

  return previous.current;
};
